export default "/images/file-minus.svg?24ccbfafe7a55cf96ed9613dc5ecf5fa";